export function safeJson<T = unknown>(input: string) {
  try {
    return {
      ok: true as const,
      value: JSON.parse(input) as T,
    };
  } catch (error) {
    return {
      ok: false as const,
      error: error as Error,
    };
  }
}
